import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 12.01 11.73"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m4.55 7 3.49-7a1.32 1.32 0 0 1 .54 1.84l-3 5 1.01-.16c.05 0 .11-.01.16-.01.57 0 1.02.46 1.02 1.03h2.83l-.25-.32h-.52l-.11-.16h1.5c.17.28.46.46.78.48-.02.05-.03.1-.05.16H5.6l2.63 2.02c.3.23.48.59.47.97 0 .33-.13.65-.36.88L4.4 7.86H.05C.03 7.81.02 7.76 0 7.7L4.55 7",
      style: {"fill":"#252668","fill-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "LO-logo"}) } }